import React, { Suspense } from "react";

import { Circle, Close, Launch } from "@mui/icons-material";
import { Box, IconButton, SxProps } from "@mui/material";

import Frame from "decodable-ui/lib/components/Frame";
import Link from "decodable-ui/lib/components/Link";

import { useGuide } from "../context";
import { UseCase } from "../useCases";
import { MDXProvider } from "./MDXProvider";
import { communitySlack, supportEmail } from "../../constants";

export function Guide({ useCase, sx }: { useCase: UseCase; sx?: SxProps }) {
  const guideCtx = useGuide();

  if (!useCase) {
    return null;
  }

  return (
    <Frame
      className="Guide"
      title="Walkthrough"
      sx={{
        maxHeight: "100%",
        isolation: "isolate",

        borderRadius: 0,
        border: "none",

        "@media (prefers-reduced-motion)": {
          animation: "none",
        },

        animation: "slide 0.5s ease-out",
        "@keyframes slide": {
          "0%": { opacity: 0 },
          "100%": { opacity: 1 },
        },

        "& h1,h2": {
          borderBottom: "1px solid rgb(90% 90% 90%)",
        },

        ...sx,
      }}
      actions={
        <IconButton
          sx={{ fontSize: "1rem" }}
          onClick={() => guideCtx.closeGuide()}
        >
          <Close />
        </IconButton>
      }
      footer={
        <Box sx={{ textAlign: "center" }}>
          Need help? You can reach us in the{" "}
          <Box component="a" target="_blank" href={communitySlack}>
            community Slack
          </Box>{" "}
          or{" "}
          <Box component="a" target="_blank" href={supportEmail}>
            email support
          </Box>
          .
        </Box>
      }
    >
      <MDXProvider>
        <Suspense
          fallback={
            <Box
              sx={{
                color: "text.secondary",
                textAlign: "center",
                paddingY: "2ch",
              }}
            >
              Error loading guide
            </Box>
          }
        >
          <Box
            sx={{
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              padding: "0 2ch 1ch",
            }}
          >
            <useCase.Content />
          </Box>
        </Suspense>
      </MDXProvider>
    </Frame>
  );
}
